export default "/048cb1f2b29308e18768c65cfd51e426596a830c/f9541d360f96791aa3f0dd381d4000ad.png";